'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_DrugRequestPharmacyResponse() {
}
export { $c_Lapp_data_DrugRequestPharmacyResponse as $c_Lapp_data_DrugRequestPharmacyResponse };
$c_Lapp_data_DrugRequestPharmacyResponse.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_DrugRequestPharmacyResponse.prototype.constructor = $c_Lapp_data_DrugRequestPharmacyResponse;
/** @constructor */
function $h_Lapp_data_DrugRequestPharmacyResponse() {
}
export { $h_Lapp_data_DrugRequestPharmacyResponse as $h_Lapp_data_DrugRequestPharmacyResponse };
$h_Lapp_data_DrugRequestPharmacyResponse.prototype = $c_Lapp_data_DrugRequestPharmacyResponse.prototype;
$c_Lapp_data_DrugRequestPharmacyResponse.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
function $isArrayOf_Lapp_data_DrugRequestPharmacyResponse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_data_DrugRequestPharmacyResponse)));
}
export { $isArrayOf_Lapp_data_DrugRequestPharmacyResponse as $isArrayOf_Lapp_data_DrugRequestPharmacyResponse };
var $d_Lapp_data_DrugRequestPharmacyResponse = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass(0, "app.data.DrugRequestPharmacyResponse", ({
  Lapp_data_DrugRequestPharmacyResponse: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lapp_data_DrugRequestPharmacyResponse as $d_Lapp_data_DrugRequestPharmacyResponse };
//# sourceMappingURL=app.data.-Drug-Request-Pharmacy-Response.js.map
